import { render } from "./WeProtect.vue?vue&type=template&id=7f3dd638"
import script from "./WeProtect.vue?vue&type=script&lang=js"
export * from "./WeProtect.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__